import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from '../static/styles/TournamentRulesPopup.module.css';
import tourRulesImg from '../static/img/MadeByESL/tour_rules.avif';

const TournamentRulesPopup = ({ isOpen, onClose }) => {
    const rounds = [
        {
            title: 'ROUND 1',
            subtitle: '(Hard elimination)',
            rules: [
                '1v1 winners qualify',
                'losers eliminated'
            ]
        },
        {
            title: 'ROUND 2',
            subtitle: '(Second Chance)',
            rules: [
                '1v1 winners qualify',
                'losers will play among themselves then winners from the losers matches qualify also'
            ]
        },
        {
            title: 'ROUND 3',
            subtitle: '(Free for all)',
            rules: [
                '1v4 4 players in a room',
                'one with the highest kills qualify'
            ]
        },
        {
            title: 'ROUND 4',
            subtitle: '(and onwards)',
            rules: [
                'Normal 1v1 matches',
                'winner qualify losers eliminated'
            ]
        }
    ];

    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img src={tourRulesImg} alt="Tournament Rules" />
                </div>

                <div className={styles.popup}>
                    <button className={styles.closeButton} onClick={onClose}>×</button>

                    <Swiper
                        modules={[Pagination]}
                        pagination={{
                            clickable: true
                        }}
                        spaceBetween={0}
                        slidesPerView={1}
                        className={styles.swiper}
                        loop
                    >
                        {rounds.map((round, index) => (
                            <SwiperSlide key={index}>
                                <div className={styles.content}>
                                    <div className={styles.roundHeader}>
                                        <h2>{round.title}</h2>
                                        <p>{round.subtitle}</p>
                                    </div>

                                    <div className={styles.rulesContainer}>
                                        {round.rules.map((rule, ruleIndex) => (
                                            <div key={ruleIndex} className={styles.rule}>
                                                {rule}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default TournamentRulesPopup;
